<template>
  <div data-miros-entry="ws-bubble" :data-miros-lang="mirosLanguage" data-miros-static-position="false"></div>
</template>

<script setup lang="ts">
import { useMiros } from '~/composables/miros'

const {
  public: { languageId },
} = useRuntimeConfig()

useMiros()

const mirosLanguage = computed(() => {
  switch (languageId) {
    case 1:
      return 'et'
    case 2:
      return 'fi'
    case 3:
      return 'ru'
    default:
      return 'et'
  }
})
</script>
